module.exports = __webpack_public_path__ + "static/media/pic-sl3.024249fa.png";